import { Link } from 'react-router-dom';

const testimonials = [
  {
    name: 'T.M様',
    area: '名古屋市西区',
    type: '相続不動産の買取',
    text: '父が亡くなり、相続した実家の処分に困っていました。近所に知られたくなかったのですが、秘密厳守で対応していただき、スムーズに売却できました。',
    rating: 5,
    result: '査定後14日で現金化',
  },
  {
    name: 'K.S様',
    area: '名古屋市千種区',
    type: '住み替えの売却相談',
    text: '住み替えのタイミングで相談したところ、売却と購入のスケジュールを丁寧に整理してくれました。押し売りがなく、安心して任せられました。',
    rating: 5,
    result: '希望通りの価格で売却',
  },
  {
    name: 'Y.O様',
    area: '愛知県外（遠方）',
    type: '空き家の売却',
    text: '遠方に住んでいて管理できない空き家を売りたかったのですが、オンラインで全て対応してもらえました。全国対応というのは本当でした。',
    rating: 5,
    result: '遠方でもスムーズに対応',
  },
];

export default function TestimonialsSection() {
  return (
    <section className="py-20 md:py-28 bg-[#F8F9FB]">
      <div className="max-w-7xl mx-auto px-4 md:px-12">
        {/* Header */}
        <div className="flex flex-col md:flex-row md:items-end md:justify-between mb-14 gap-6">
          <div>
            <div className="flex items-center gap-3 mb-4">
              <div className="h-px w-10 bg-emerald-500" />
              <span className="text-emerald-600 text-xs font-semibold tracking-[0.2em] uppercase">Testimonials</span>
            </div>
            <h2 className="text-[#1A2B4A] text-2xl md:text-4xl font-bold">お客様の声</h2>
          </div>
          <Link
            to="/testimonials"
            className="inline-flex items-center gap-2 text-[#1A2B4A] text-sm font-medium border border-[#1A2B4A]/20 px-5 py-2.5 rounded-full hover:bg-[#1A2B4A] hover:text-white hover:border-[#1A2B4A] transition-all duration-200 cursor-pointer whitespace-nowrap self-start md:self-auto"
          >
            すべて見る
            <i className="ri-arrow-right-line" />
          </Link>
        </div>

        {/* Cards */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {testimonials.map((t, index) => (
            <div key={index} className="bg-white rounded-2xl p-7 flex flex-col relative overflow-hidden">
              {/* Quote mark */}
              <div className="absolute top-4 right-5 text-7xl font-serif text-gray-100 leading-none select-none">&ldquo;</div>

              {/* Stars */}
              <div className="flex items-center gap-1 mb-5">
                {Array.from({ length: t.rating }).map((_, i) => (
                  <i key={i} className="ri-star-fill text-amber-400 text-sm" />
                ))}
              </div>

              {/* Text */}
              <p className="text-gray-600 text-sm leading-relaxed mb-6 flex-1 relative z-10">
                {t.text}
              </p>

              {/* Result badge */}
              <div className="flex items-center gap-2 bg-emerald-50 rounded-lg px-4 py-2.5 mb-5">
                <i className="ri-checkbox-circle-fill text-emerald-500 text-sm" />
                <span className="text-emerald-700 text-xs font-semibold">{t.result}</span>
              </div>

              {/* Customer */}
              <div className="flex items-center gap-3 pt-4 border-t border-gray-100">
                <div className="w-9 h-9 rounded-full bg-[#F0F4FA] flex items-center justify-center flex-shrink-0">
                  <i className="ri-user-line text-[#1A2B4A] text-sm" />
                </div>
                <div>
                  <p className="text-[#1A2B4A] font-semibold text-sm">{t.name}</p>
                  <p className="text-gray-400 text-xs">{t.area} ／ {t.type}</p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}